import hospitals from './hospitals';

const hospitalService = [{
    matcher: 'hospitals',
    reply: config => {
        if(config.method==='post') {
            return [200, hospitals[0]];
        } else {
            const {predicate} = config.params;
            let data;
            if(predicate===''){
                data = hospitals;
            } else if(predicate?.node()?.selector?.()==='value') {
                const name = predicate.node().expectation();
                const regexp = new RegExp(name.replaceAll('*', '.*'));
                data = hospitals.filter(hospital => regexp.test(hospital.name));
            } else {
                data = hospitals;
            }
            return [200, data];
        }
    }
}, {
    matcher:  /hospitals\/(.*)/,
    reply: config => {
        const id = /hospitals\/(.*)/.exec(config.url)[1];
        const hospital = hospitals.find(hospital => hospital.code === id);
        return [200, hospital];
    }
}];

export default hospitalService;